import { NbDialogModule } from '@nebular/theme';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharedModule } from './../../shared/shared.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PadRoutingModule } from './pad-routing.module';
// service
// component
import { PadListComponent } from './pad-list/pad-list.component';
import { PadComponent } from './pad/pad.component';
import { PadDetailsComponent } from './pad-details/pad-details.component';
import { PadRealtimeComponent } from './pad-realtime/pad-realtime.component';
import { RealtimeModule } from '../treatments/realtime/realtime.module';

@NgModule({
  declarations: [PadListComponent, PadComponent, PadDetailsComponent, PadRealtimeComponent],
  imports: [
    CommonModule,
    PadRoutingModule,
    NgbPaginationModule,
    Ng2SmartTableModule,
    SharedModule,
    HighchartsChartModule,
    NbDialogModule.forRoot(),
    RealtimeModule
  ],
  exports: [],
  providers: [],
  entryComponents: []
})
export class PadModule { }
